<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';

    @Component({
        props: {
            propOpened: { type: Boolean, required: true, default: false },
            propSurveyId: { type: Number, required: false, default: null },
        }
    })
    export default class SurveyOpenerDialog extends Vue
    {
        get opened(): boolean { return this.$props.propOpened; }
        get surveyId(): number | null { return this.$props.propSurveyId as number; }

        showAccessLinks()
        {
            this.$emit('show-access-links', this.surveyId);
        }

        startSurvey()
        {
            this.$emit('start-survey', this.surveyId);
        }

        close()
        {
            this.$emit('close-dialog');
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Opening a survey</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p class="lead">
                            You're about to open the survey.
                        </p><br />

                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h5>Access links</h5>
                                        <p>These links will let your respondents access the survey with just one click. Why not (re)send them now?​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="showAccessLinks">Access links</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="modal-footer">
                        <button @click="startSurvey" type="button" class="btn btn-primary">Open the survey</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
